import { Component } from '@angular/core';
import { TreatmentPlanComponent } from 'src/app/pages/treatment-plan/treatment-plan.component';

@Component({
  selector: 'app-treatment-plan-detail-v2',
  templateUrl: './treatment-plan-detail.component.html',
  styleUrls: [
    '../../../../pages/treatment-plan/treatment-plan.component.sass',
    './treatment-plan-detail.component.sass'
  ]
})
export class TreatmentPlanDetailV2Component extends TreatmentPlanComponent {
  // Extend modal confirmation type for v2 to include product_photo and v2-only vars
  override removeConfirmType: 'product' | 'photo' | 'product_photo' = 'product';
  removeConfirmProductId: string = '';
  removeConfirmProductPhotoType: 'bottle' | 'box' | 'label' | null = null;

  /**
   * Override do changeTab para a aba "Intercorrência":
   * em vez de renderizar dentro da tela do plano, navega para a subrota dedicada.
   * O resto das abas mantém o comportamento herdado.
   */
  override changeTab(tab: 'info' | 'products' | 'photos' | 'intercorrencias'): void {
    if (tab === 'intercorrencias') {
      // Salva o plano antes de sair (mesmo padrão do changeTab original).
      this.requestSave('tab_change', false);
      this.hasUnsavedChanges = false;
      this.router.navigate(['/main/v2/treatment-plan', this.treatmentPlanId, 'incident']);
      return;
    }
    super.changeTab(tab);
  }

  /**
   * Se chegamos na rota com `?tab=intercorrencias` (deep link, bookmark ou histórico
   * do navegador), curto-circuita o init e redireciona imediatamente para a subrota.
   *
   * Pontos importantes:
   * - Não chamamos super.ngOnInit() porque ele dispararia GET treatment-plan,
   *   GET incident-questions e GET incident-report duas vezes (uma aqui, outra na
   *   subrota), além de iniciar listeners desnecessários para um componente que
   *   está prestes a ser destruído.
   * - Usamos replaceUrl: true para não acumular histórico — sem isso, clicar em
   *   "Voltar" volta para `?tab=intercorrencias` que dispara o redirect de novo,
   *   gerando um efeito de loop ao tentar voltar.
   *
   * Inspeciona a URL via this.router.url (acessível via parent injection) para
   * detectar o deep-link sem depender de this.route que é privado no parent.
   */
  override ngOnInit(): void {
    const url = this.router.url || '';
    if (/[?&]tab=intercorrencias(?:&|$)/.test(url)) {
      // Extrai o id direto da URL (formato /main/v2/treatment-plan/{id}?...)
      const match = url.match(/\/treatment-plan\/([^/?]+)/);
      const idFromUrl = match ? match[1] : '';
      if (idFromUrl) {
        this.router.navigate(['/main/v2/treatment-plan', idFromUrl, 'incident'], { replaceUrl: true });
        return;
      }
    }
    super.ngOnInit();
  }

  override goBack(): void {
    const navigateBack = () => {
      this.router.navigate(['/main/v2/treatment-plans']);
    };

    if (this.hasUnsavedChanges) {
      if (confirm('Há alterações não salvas. Se sair agora, essas alterações serão perdidas. Deseja continuar?')) {
        this.removeBeforeUnloadListener();
        navigateBack();
      }
    } else {
      navigateBack();
    }
  }

  override cancelRemoveConfirm(): void {
    // call parent cleanup
    super.cancelRemoveConfirm();
    // clear v2-only product-photo modal vars
    this.removeConfirmProductId = '';
    this.removeConfirmProductPhotoType = null;
  }

  async confirmRemoveProductPhoto(): Promise<void> {
    const productId = this.removeConfirmProductId;
    const photoType = this.removeConfirmProductPhotoType;

    if (!productId || !photoType) {
      console.warn('Dados de remoção de foto do produto incompletos (v2)');
      return;
    }

    this.removeConfirmLoading = true;

    try {
      await this.removeProductPhoto(productId, photoType);
      this.showRemoveConfirmModal = false;
    } catch (error) {
      console.error('Erro ao remover foto do produto (v2):', error);
    } finally {
      this.removeConfirmLoading = false;
      this.removeConfirmProductId = '';
      this.removeConfirmProductPhotoType = null;
    }
  }
}
